/* global AGA */
import AutoNumeric from 'autonumeric';

AGA.Number = (function () {

    // Obter implementação base
    var baseMethods = AGA.BaseInputControl();
    var publicMethods = $.extend({}, baseMethods);
    var initializedClassName = "aga-initialized";

    // customizações
    var ensureInit = function (element) {
        if (!$(element).hasClass(initializedClassName)) {
            $(element).addClass(initializedClassName);

            if (!AutoNumeric.isManagedByAutoNumeric(element)) {
                var decimalPlacesVal = $(element).data('decimalplaces');

                return new AutoNumeric(element, {
                    digitGroupSeparator: '.',
                    decimalCharacter: ',',
                    decimalPlaces: decimalPlacesVal
                });
            }
        }

        return AutoNumeric.getAutoNumericElement(element);
    };

    var valueFromElement = function (element) {
        var anElement = ensureInit(element);
        var strValue = anElement.getNumericString();

        if (strValue === "") return 0;
        var nrDec = $(element).attr("data-m-dec");
        if (nrDec === "0" || nrDec === 0)
            return parseInt(strValue);
        return parseFloat(strValue);
    };
    
    publicMethods.getValue = function (selector) {
        var element = AGA.Helper.resolveElement(selector);
        if (element) {
            return valueFromElement(element);
        }
        return 0;
    };

    publicMethods.setValue = function (selector, value) {
        var element = AGA.Helper.resolveElement(selector);
        if (element) {
            var anElement = ensureInit(element);
            anElement.set(value);
        }
    };

    publicMethods.internalChange = function (input) {
        AGA.Form.dispatchChange(input,
            function () {
                var value = valueFromElement(input);
                return {
                    target: input,
                    currentTarget: input,
                    value: value,
                    isNull: false
                };
            });
    };

    publicMethods.clear = function (selector) {
        publicMethods.setValue(selector, 0);
    };

    publicMethods.getControlClass = function () { return "aga-number" };

    publicMethods.initAll = function () {
        $(".aga-number:not(." + initializedClassName + ")").each(function (i, ele) {
            ensureInit(ele);
        });
        $(".aga-number").addClass(initializedClassName);        
    };
    
    // retornar implementação final
    return publicMethods;

})();

// adicionar reader de valores no AGA.Form
AGA.Form.addControl(AGA.Number);
